import { Alert, Button, Group, Text } from '@mantine/core';
import { AlertCircle } from 'react-feather';

interface AttendanceLoadErrorProps {
  message: string | null;
  onRetry: () => void;
}

/**
 * MED-1360: the attendance section when its data did not load. It shows the
 * error and a Retry button, and no form: there is nothing to edit or clear.
 * Retry runs the load again (the section shows its loader meanwhile), so a
 * network blip never strands the user.
 */
export function AttendanceLoadError({ message, onRetry }: AttendanceLoadErrorProps) {
  return (
    <Alert icon={<AlertCircle size={16} />} color="red" variant="light">
      {/* The button keeps its width; a long message wraps instead of
          squeezing the label down to "Ret". */}
      <Group justify="space-between" wrap="nowrap" gap="sm">
        <Text size="sm" style={{ flex: 1, minWidth: 0 }}>
          {message}
        </Text>
        <Button
          size="xs"
          variant="light"
          color="red"
          onClick={onRetry}
          style={{ flexShrink: 0 }}
        >
          Retry
        </Button>
      </Group>
    </Alert>
  );
}
